"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockUseCarousel = void 0;
const mockUseCarousel = () => {
  // matchMedia not implemented for use with Jest
  Object.defineProperty(window, "matchMedia", {
    writable: true,
    /* to allow matchMedia property configurable in Jest usually not writable */
    value: jest.fn().mockImplementation(query => ({
      // Jest Documentation official workaround: https://jestjs.io/docs/manual-mocks#mocking-methods-which-are-not-implemented-in-jsdom
      matches: false,
      media: query,
      onchange: null,
      addEventListener: jest.fn(),
      removeEventListener: jest.fn(),
      dispatchEvent: jest.fn()
    }))
  });
  const mockIntersectionObserver = jest.fn();
  const mockResizeObserver = jest.fn();
  const mockMutationObserver = jest.fn();
  const mockReturnObj = {
    observe: () => null,
    unobserve: () => null,
    disconnect: () => null
  };
  mockIntersectionObserver.mockReturnValue(mockReturnObj);
  mockResizeObserver.mockReturnValue(mockReturnObj);
  mockMutationObserver.mockReturnValue(mockReturnObj);

  // These browser apis needed to be mocked as not working out of the box in Jest also
  window.IntersectionObserver = mockIntersectionObserver;
  window.ResizeObserver = mockResizeObserver;
  window.MutationObserver = mockMutationObserver;
};
exports.mockUseCarousel = mockUseCarousel;